var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSalesforceSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4647 7.06432C22.4954 7.06432 21.5754 7.2756 20.7481 7.6543C19.7844 6.35252 18.2378 5.5083 16.4938 5.5083C15.9748 5.5083 15.4738 5.58424 15 5.72375L9.72656 14.8484L15 23.973C15.5857 23.4991 16.0879 22.9261 16.4809 22.2794C17.0653 22.5017 17.6987 22.6245 18.361 22.6245C20.2657 22.6245 21.9347 21.6175 22.8663 20.1073C23.0634 20.1252 23.2629 20.1348 23.4647 20.1348C27.0741 20.1349 30 17.2089 30 13.5996C30 9.9902 27.0741 7.06432 23.4647 7.06432Z",
    fill: "#00B8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1933 6.66557C11.9998 5.37967 10.2953 4.57471 8.40252 4.57471C4.7932 4.57471 1.86727 7.50064 1.86727 11.11C1.86727 11.7914 1.97168 12.4485 2.16521 13.0661C0.852656 14.0288 0 15.5815 0 17.3341C0 20.2559 2.36865 22.6246 5.29049 22.6246C5.36906 22.6246 5.44699 22.6221 5.52469 22.6187C6.70523 24.3149 8.66883 25.4254 10.8921 25.4254C12.4484 25.4254 13.8776 24.8814 15 23.9731V5.72373C14.3339 5.91984 13.7221 6.24275 13.1933 6.66557Z",
    fill: "#5CD4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSalesforceSmall);
export default __webpack_public_path__ + "static/media/icon-salesforce-small.0b19084b45b4a58bf563df47fad05197.svg";
export { ForwardRef as ReactComponent };